import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {AthleteEventsChartRepository} from "./athlete-events-chart.repository";
import {AthleteEventsChartFactory} from "./athlete-events-chart.factory";


export class AthleteEventsChartDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, AthleteEventsChartRepository, AthleteEventsChartFactory, DomainRequestManager, AthleteEventsChartFactory];
}